<template>
    <button
        :type="type"
        :class="'p-2 bg-'
        +color+'-500 border border-transparent rounded-md font-semibold text-xs text-'+textcolor+' uppercase tracking-widest hover:bg-'
        +color+'-400 focus:outline-none focus:border-'+color+'-700 focus:ring focus:ring-'
        +color+'-100 active:bg-'+color+'-400 disabled:opacity-25 transition'
        "
        :disabled="loader"
    >
        {{ text ?? text }}

        <slot v-if="!loader" name="icon" />

        <svg v-else class="inline animate-spin h-4 w-4 align-text-bottom" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
    </button>
</template>

<script>
    import { defineComponent } from 'vue'

    export default defineComponent({
        props: {
            type: {
                type: String,
                default: 'button',
            },
            loader: Boolean,
            text: String,
            color: {
                type: String,
                default: 'greendack'
            },
            textcolor: {
                type: String,
                default: 'white'
            },
        }
    })
</script>
